module.exports = __webpack_public_path__ + "static/3-60783eee4d92567dc2d902211c1f61ff.png";